(function () {
    'use strict';

    function searchField() {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/searchField.html',
            link: function (scope) {
            }
        };
    }

    searchField.$inject = [];

    angular.module('ecap.workflow').directive('searchField', searchField);
})();
